import { isApiError } from '@/lib/api/http-client';
import { LOGIN_ERROR_REASONS, type LoginErrorReasonResponse } from '../schemas/login.schemas';
import {
  validateLoginLinkErrorCodeSchema,
  type ValidateLoginLinkErrorCode,
} from '../schemas/login-link.schemas';

const ERROR_REASON_KEYS: Record<LoginErrorReasonResponse, string> = {
  expired: 'login.token_validation.error.expired',
  already_used: 'login.token_validation.error.already_used',
  invalid: 'login.token_validation.error.invalid',
  session_expired: 'login.token_validation.error.session_expired',
};

const VALIDATION_LINK_ERROR_TO_REASON: Record<
  ValidateLoginLinkErrorCode,
  LoginErrorReasonResponse
> = {
  LOGIN_TOKEN_EXPIRED: LOGIN_ERROR_REASONS.expired,
  LOGIN_TOKEN_USED: LOGIN_ERROR_REASONS.already_used,
  LOGIN_TOKEN_INVALID: LOGIN_ERROR_REASONS.invalid,
};

export const getErrorReasonKey = (reason: LoginErrorReasonResponse) => {
  return ERROR_REASON_KEYS[reason] || ERROR_REASON_KEYS.invalid;
};

/**
 * Extracts the login error reason from an unknown error object, typically an API error returned from the backend.
 * It checks if the error is an API error and if its code matches one of the known login error reasons.
 * If a valid reason is found, it returns it; otherwise, it defaults to 'invalid'.
 */
export const getValidationLinkErrorReason = (error: unknown): LoginErrorReasonResponse => {
  if (isApiError(error)) {
    const parsed = validateLoginLinkErrorCodeSchema.safeParse(error.code);
    if (parsed.success) {
      return VALIDATION_LINK_ERROR_TO_REASON[parsed.data];
    }
  }

  return LOGIN_ERROR_REASONS.invalid;
};
